import { UserOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, InputNumber, Spin } from 'antd';
import Header from 'components/Header/Header';
// import ChampionLeague from 'components/Prediction/ChampionLeague';
// import PredictionWidget from 'components/Prediction/PredictionWidget';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import qs from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import {
  createPredictions,
  getAllSetting,
  getFP,
  getIP,
  getMatchList,
  getTime,
  ssoVerify
} from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE, LocalStorageKey, SETTING_KEYS } from 'utils/common/const';
import RightGif from '../../components/RightGif';
import LeftArrowIcon from '../../assets/images/left.png';
import RightArrowIcon from '../../assets/images/right.png';
// import ChampionLeague from 'components/Prediction/ChampionLeague';

const SSO_PARAMS = ['playerid', 'timestamp', 'nonce', 'token', 'sign'];

const daysOfWeek = {
  Monday: 'Thứ Hai',
  Tuesday: 'Thứ Ba',
  Wednesday: 'Thứ Tư',
  Thursday: 'Thứ Năm',
  Friday: 'Thứ Sáu',
  Saturday: 'Thứ Bảy',
  Sunday: 'Chủ Nhật'
};

/** Chuẩn hóa phản hồi /time (số giây/ms, chuỗi ngày, hoặc { data }) → epoch ms */
const parseServerTimeToMs = (raw) => {
  if (raw == null) return null;
  let ts = raw;
  if (typeof ts === 'object' && ts !== null && 'data' in ts && ts.data !== undefined) {
    ts = ts.data;
  }
  if (typeof ts === 'number') {
    return ts < 1e12 ? ts * 1000 : ts;
  }
  if (typeof ts === 'string') {
    const trimmed = ts.trim();
    const d = dayjs(trimmed).valueOf();
    if (Number.isFinite(d) && !Number.isNaN(d)) return d;
    const alt = dayjs(trimmed.replace(/\//g, '-')).valueOf();
    if (Number.isFinite(alt) && !Number.isNaN(alt)) return alt;
    const n = Number(trimmed);
    if (Number.isFinite(n)) return n < 1e12 ? n * 1000 : n;
  }
  return null;
};

const OK9Page = () => {
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [listDataMatch, setListDataMatch] = useState([]);
  const [timeServer, setTimeServer] = useState(null);
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [dataSettings, setDataSettings] = useState([]);
  const [isSsoLoggedIn, setIsSsoLoggedIn] = useState(() => {
    try {
      const token = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);
      const username = localStorage.getItem('ok9_username');
      return !!(token && username);
    } catch {
      return false;
    }
  });

  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'today', 'tomorrow'
  const [showSchedulePopup, setShowSchedulePopup] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  const serverClockRef = useRef({ serverMs: null, localMs: null });
  const [countdownTick, setCountdownTick] = useState(0);

  useEffect(() => {
    const ms = parseServerTimeToMs(timeServer);
    if (ms != null && Number.isFinite(ms)) {
      serverClockRef.current = { serverMs: ms, localMs: Date.now() };
    }
  }, [timeServer]);

  useEffect(() => {
    const id = window.setInterval(() => setCountdownTick((x) => x + 1), 1000);
    return () => window.clearInterval(id);
  }, []);

  const getCurrentNowMs = () => {
    const { serverMs, localMs } = serverClockRef.current;
    if (serverMs != null && localMs != null) {
      return serverMs + (Date.now() - localMs);
    }
    return Date.now();
  };

  const getKickoffMs = (match) => {
    if (typeof match.startTime === 'number') return match.startTime * 1000;
    if (match.countdown) return new Date(match.countdown).getTime();
    return 0;
  };

  // Restore SSO account on mount (e.g. after page reload or navigation)
  useEffect(() => {
    if (!isSsoLoggedIn) return;
    try {
      const username = localStorage.getItem('ok9_username');
      if (username) {
        form.setFieldsValue({ account: username });
      }
    } catch {
      // ignore
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // SSO login: when redirected with SSO query params, verify and store token
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const playerid = params.get('playerid');
    const timestamp = params.get('timestamp');
    const nonce = params.get('nonce');
    const token = params.get('token');
    const sign = params.get('sign');

    if (!playerid || !timestamp || !nonce || !token || !sign) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await ssoVerify({ playerid, timestamp, nonce, token, sign });

        if (cancelled) return;

        const userToken = res?.data?.userToken || null;

        if (userToken) {
          localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, userToken);
          try {
            localStorage.setItem('ok9_username', playerid);
          } catch {
            // ignore
          }
          // Pre-fill account field with playerid
          form.setFieldsValue({ account: playerid });
          setIsSsoLoggedIn(true);
        }
      } catch (err) {
        if (cancelled) return;
        console.error('[SSO] verify failed:', err);
      } finally {
        if (!cancelled) {
          // Maybe have clean SSO params from URL
          // for (const key of SSO_PARAMS) params.delete(key);
          // const remaining = params.toString();
          // const cleanUrl = remaining
          //   ? `${window.location.pathname}?${remaining}`
          //   : window.location.pathname;
          // window.history.replaceState({}, '', cleanUrl);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bankDigitRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const handleBankDigitChange = (index) => (value) => {
    if (value !== null && value !== undefined && String(value).length >= 1 && index < 3) {
      bankDigitRefs[index + 1].current?.focus();
    }
    // Khi InputNumber xóa ký tự không hợp lệ (value = null), giữ focus ô hiện tại
    if (value === null) {
      bankDigitRefs[index].current?.focus();
    }
  };

  const handleBankDigitKeyDown = (index) => (e) => {
    // Chỉ cho phép nhập số, Backspace, Delete, Tab, mũi tên
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (!allowedKeys.includes(e.key) && !/^[0-9]$/.test(e.key)) {
      e.preventDefault();
      return;
    }

    // Nhấn Backspace khi ô rỗng thì nhảy về ô trước (chỉ focus, không xóa)
    if (e.key === 'Backspace' && index > 0 && !e.target.value) {
      e.preventDefault();
      bankDigitRefs[index - 1].current?.focus();
    }
  };

  // Hàm lọc trận đấu theo tab được chọn
  const getFilteredMatches = () => {
    if (!listDataMatch || listDataMatch.length === 0) return [];

    const now = dayjs();
    const today = now.format('YYYY-MM-DD');
    const tomorrow = now.add(1, 'day').format('YYYY-MM-DD');

    switch (activeTab) {
      case 'today':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === today;
        });
      case 'tomorrow':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === tomorrow;
        });
      case 'all':
      default:
        return listDataMatch;
    }
  };

  const handleLeagueClick = (leagueId) => {
    setSelectedLeagues((prevSelectedLeagues) =>
      prevSelectedLeagues.includes(leagueId)
        ? prevSelectedLeagues.filter((id) => id !== leagueId)
        : [...prevSelectedLeagues, leagueId]
    );
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const leagueListRef = React.createRef();

  const scrollLeft = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft - 100);
    }
  };

  const scrollRight = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft + 100);
    }
  };

  useEffect(() => {
    fetchAllSetting();
    fetchIP();
    fetchFP();
    fetchTimeServer();
  }, []);

  useEffect(() => {
    fetchDataScheduByLS();
  }, []);

  // Track window width để responsive
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Set initial width
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchIP = async () => {
    try {
      const res = await getIP();
      setIP(res);
    } catch (e) {}
  };

  const fetchFP = async () => {
    try {
      const res = await getFP();
      setFP(res);
    } catch (e) {}
  };

  const fetchTimeServer = async () => {
    try {
      const res = await getTime();
      setTimeServer(res);
    } catch (e) {}
  };

  const fetchDataScheduByLS = async () => {
    try {
      setIsLoading(true);
      const res2 = await getMatchList({
        site: CONST_SITE.OK9
      });

      const dataMatch2 =
        res2?.data?.length > 0
          ? res2.data.map((item) => {
              const formatCountDown = dayjs.unix(item.startTime);
              return { ...item, countdown: new Date(formatCountDown) };
            })
          : [];

      setListDataMatch(dataMatch2 || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching match list:', error);
      setIsLoading(false);
    }
  };

  const fetchAllSetting = async (data) => {
    try {
      setIsLoading(true);
      const res = await getAllSetting(qs.stringify({ site: CONST_SITE.OK9 }));
      setDataSettings(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const TIMEOUT_DURATION = 10000; // 10 seconds

  const createPredictionsWithTimeout = (data) => {
    return Promise.race([
      createPredictions(data),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), TIMEOUT_DURATION)
      )
    ]);
  };

  const onFinishForm = async (data) => {
    try {
      const filteredMatches = getFilteredMatches();
      if (filteredMatches?.length === 0) return;

      if (!data?.account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đăng nhập!'
        });
        return;
      }

      // Kiểm tra 4 số tài khoản ngân hàng đã nhập đủ chưa (bỏ qua khi SSO)
      const bankDigits = [data?.bankDigit1, data?.bankDigit2, data?.bankDigit3, data?.bankDigit4];
      if (!isSsoLoggedIn) {
        const hasEmptyBankDigit = bankDigits.some(
          (digit) => digit === undefined || digit === null || digit === ''
        );
        if (hasEmptyBankDigit) {
          notification.warning({
            message: 'Cảnh báo',
            description: 'Vui lòng nhập đủ 4 số tài khoản ngân hàng!'
          });
          return;
        }
      }

      // Validate that both home and away scores are provided for each match
      const hasInvalidScores = Object.entries(data).some(([key, value]) => {
        // Bỏ qua field account và các field không phải score
        if (key === 'account' || !key.includes('_')) return false;

        const parts = key.split('_');
        if (parts.length !== 2) return false;

        const [scoreType, matchId] = parts;
        if (!['homeScore', 'awayScore'].includes(scoreType)) return false;

        const otherScoreType = scoreType === 'homeScore' ? 'awayScore' : 'homeScore';
        const otherScoreKey = `${otherScoreType}_${matchId}`;
        const otherValue = data[otherScoreKey];

        // Kiểm tra nếu một trong hai score có giá trị nhưng score kia không có
        const hasValue = value !== undefined && value !== null && value !== '';
        const hasOtherValue = otherValue !== undefined && otherValue !== null && otherValue !== '';

        if (hasValue && !hasOtherValue) {
          return true;
        }

        return false;
      });

      if (hasInvalidScores) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập đầy đủ cả hai bên tỉ số cho mỗi trận đấu!'
        });
        return;
      }

      setIsLoadingSubmit(true);

      const lastBankNumber = isSsoLoggedIn ? '' : bankDigits.join('');
      const resultGroup = groupScoresByMatchId(data, IP, FP, filteredMatches, lastBankNumber);

      if (resultGroup.length === 0) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng dự đoán ít nhất một trận đấu!'
        });
        setIsLoadingSubmit(false);
        return;
      }

      //   const requestData = { predictions: resultGroup, lastBankNumber: bankDigits.join('') };
      console.log('Submitting predictions:', resultGroup);
      const res = await createPredictionsWithTimeout(resultGroup);
      if (res?.code === 0) {
        notification.success({
          message: 'Thành công',
          description: 'Dự đoán tỉ số thành công!'
        });
        form.resetFields(Object.keys(form.getFieldsValue()).filter((key) => key !== 'account'));
      } else {
        if (res.valid === false) {
          notification.error({
            message: res.title_mess,
            description: res?.text_mess
          });
        } else {
          notification.error({
            message: 'Lỗi',
            description: res?.message
          });
        }
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      if (error?.response?.status === 401) {
        setIsLoadingSubmit(false);
        return;
      }
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    if (!errorInfo?.values?.account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tên đang nhập!'
      });
    } else {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng điền đầy đủ thông tin!'
      });
    }
  };

  const groupScoresByMatchId = (input, ip, fp, matchInfo, lastBankNumber) => {
    const groupedMatches = Object.entries(input).reduce((acc, [key, value]) => {
      if (key === 'account') return acc;

      const parts = key.split('_');
      if (parts.length !== 2) return acc;

      const [scoreType, matchId] = parts;
      if (!matchId || !['homeScore', 'awayScore', 'sameScore'].includes(scoreType)) return acc;

      // Kiểm tra giá trị hợp lệ
      if (value === undefined || value === null || value === '') return acc;

      if (!acc[matchId]) {
        acc[matchId] = {
          matchId,
          account: input.account,
          lastBankNumber: lastBankNumber,
          homeScore: undefined,
          awayScore: undefined,
          sameScore: undefined
        };
      }

      if (scoreType === 'homeScore') {
        acc[matchId].homeScore = value;
      } else if (scoreType === 'awayScore') {
        acc[matchId].awayScore = value;
      } else if (scoreType === 'sameScore') {
        acc[matchId].sameScore = value;
      }

      return acc;
    }, {});

    return Object.values(groupedMatches)
      .filter(
        (match) =>
          match.homeScore !== undefined &&
          match.awayScore !== undefined &&
          match.sameScore !== undefined &&
          match.homeScore !== null &&
          match.awayScore !== null &&
          match.sameScore !== null &&
          match.homeScore !== '' &&
          match.sameScore !== '' &&
          match.awayScore !== ''
      )
      .map(({ matchId, account, homeScore, awayScore, sameScore }) => {
        const matchDetails = matchInfo.find(
          (match) => parseInt(match.matchId) === parseInt(matchId)
        );

        return {
          matchId,
          homeScore,
          awayScore,
          sameScore,
          account,
          lastBankNumber,
          ip,
          fp,
          homeName: matchDetails ? matchDetails.homeName : 'Unknown',
          awayName: matchDetails ? matchDetails.awayName : 'Unknown',
          site: SITE
        };
      });
  };

  const leagues = [
    // { id: 1, name: 'WORLD CUP', logo: '/assets/images/logo/1.png' },
    { id: 2, name: 'UEFA Champions League', logo: '/assets/images/logo/2.webp' },
    { id: 3, name: 'UEFA Europa League', logo: '/assets/images/logo/3.webp' },
    { id: 4, name: 'English Premier League', logo: '/assets/images/logo/4.png' },
    { id: 5, name: 'Spanish La Liga', logo: '/assets/images/logo/5.png' },
    { id: 6, name: 'Italy Serie A', logo: '/assets/images/logo/6.png' },
    { id: 7, name: 'German Bundesliga', logo: '/assets/images/logo/7.webp' },
    { id: 8, name: 'France Ligue 1', logo: '/assets/images/logo/8.webp' },
    { id: 9, name: 'England FA Cup', logo: '/assets/images/logo/9.png' },
    { id: 10, name: 'Spain Supercopa de Espana', logo: '/assets/images/logo/10.webp' },
    { id: 13, name: 'International Friendly', logo: '/assets/images/logo/13.png' }
    // { id: 11, name: 'French Cup', logo: '/assets/images/logo/11.png' }
  ];

  /** Đếm ngược tới giờ bóng lăn; HH:mm:ss; giờ ≥ 100 không pad 2 chữ (hiển thị 3+ chữ số tự nhiên) */
  const formatMatchCountdown = (match) => {
    void countdownTick;
    const endMs = getKickoffMs(match);
    if (!endMs) return '--:--:--';
    const diffSec = Math.floor((endMs - getCurrentNowMs()) / 1000);
    if (diffSec <= 0) return '00:00:00';
    const h = Math.floor(diffSec / 3600);
    const m = Math.floor((diffSec % 3600) / 60);
    const s = diffSec % 60;
    const hStr = h < 100 ? String(h).padStart(2, '0') : String(h);
    return `${hStr}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const showListItemMatch = (matchList) => {
    if (!matchList || matchList.length <= 0) {
      return <p>{dataSettings?.find((item) => item.key === SETTING_KEYS.NO_DATA)?.content}</p>;
    }

    const filteredMatchList =
      selectedLeagues.length > 0
        ? matchList.filter((item) =>
            selectedLeagues.includes(leagues.find((league) => league.name === item.leagueName)?.id)
          )
        : matchList;

    const nowMs = getCurrentNowMs();
    return filteredMatchList
      .filter((item) => getKickoffMs(item) > nowMs)
      .map((item, index) => {
        const matchDayOfWeek = daysOfWeek[dayjs(item.startTime * 1000).format('dddd')];
        const leagueInfo = leagues.find((league) => league.name === item?.leagueName);
        const leagueLogo =
          item.leagueLogo || leagueInfo?.logo || '/assets/images/header/logomax.png';
        const displayLeagueName =
          item?.leagueName === 'International Friendly' ? 'Giao hữu quốc tế' : item?.leagueName;
        const isDisabled = getKickoffMs(item) <= nowMs;

        return (
          <div
            key={index}
            className={twMerge(
              'rounded-xl overflow-hidden',
              isDisabled ? 'opacity-50 pointer-events-none' : ''
            )}
            style={{ fontFamily: "'Times New Roman', serif" }}
          >
            {/* Top green bar */}
            <div className="bg-[#36A638] px-3 py-1.5 flex justify-between items-center min-h-[32px]">
              <p className="text-white text-[12px] md:text-[14px] font-['Times_New_Roman'] font-bold leading-tight tracking-[0.22px] whitespace-nowrap">
                {`${dayjs(item.startTime * 1000).format('HH:mm')} ${matchDayOfWeek}, Ngày ${dayjs(item.startTime * 1000).format('DD/MM/YYYY')}`}
              </p>
              <div className="flex items-center ml-2">
                <img
                  src="/assets/images/match/live.png"
                  alt="Live"
                  className="h-5 object-contain flex-shrink-0"
                />
              </div>
            </div>

            {/* Card body */}
            <div
              className="relative z-10 px-3 pt-3 pb-3 bg-[length:102%_102%] bg-center bg-no-repeat"
              style={{
                backgroundImage: 'url(/assets/images/match/bg_item.png)',
                border: '2px solid rgba(134,202,136,0.4)',
                borderTop: 'none',
                borderRadius: '0 0 12px 12px'
              }}
            >
              {/* Teams + Score row */}
              <div className="flex items-start justify-between gap-0">
                {/* Home team */}
                <div className="flex flex-col items-center mt-6 gap-1 w-[75px] flex-shrink-0">
                  <div
                    className="w-[50px] h-[50px] rounded-full overflow-hidden bg-white flex items-center justify-center p-[1.5px]"
                    style={{
                      border: '1.2px solid #fff',
                      boxShadow: 'inset 0 0 4px rgba(0,0,0,0.25)'
                    }}
                  >
                    <img
                      src={item.homeLogo}
                      alt={item.homeName}
                      className="w-[90%] h-[90%] max-w-[90%] max-h-[90%] object-contain object-center shrink-0"
                    />
                  </div>
                  <p className="font-['Times_New_Roman'] text-[13px] text-[#36A638] font-bold text-center leading-[16px] tracking-[0.26px] line-clamp-2 w-full">
                    {item.homeName}
                  </p>
                </div>

                {/* Center: countdown + score */}
                <div className="flex-1 flex flex-col items-center gap-1.5 min-w-0">
                  {/* League logo */}
                  {leagueLogo && (
                    <img src={leagueLogo} alt="" className="h-[36px] object-contain" />
                  )}
                  <div className="flex flex-col items-center">
                    <p className="font-['Times_New_Roman'] text-[#000] text-[13px] font-bold leading-tight tracking-[0.24px]">
                      Thời gian dự đoán còn
                    </p>
                    <p className="font-['Times_New_Roman'] text-[#FF0000] text-[15px] font-bold tabular-nums tracking-[0.3px]">
                      {formatMatchCountdown(item)}
                    </p>
                  </div>
                  {/* Score inputs */}
                  <div className="flex items-center gap-2">
                    <Form.Item className="m-0" name={`homeScore_${item.matchId}`}>
                      <InputNumber
                        disabled={isDisabled}
                        controls={false}
                        min={0}
                        max={99}
                        maxLength={2}
                        placeholder="-"
                        className="!w-[32px] !h-[32px] text-center text-sm font-bold text-[#3E4C5C] rounded-[6px] [&_input]:!text-center [&_input]:!p-0"
                        style={{ border: '0.83px solid #DCDFE3', textAlign: 'center' }}
                      />
                    </Form.Item>
                    <span className="font-bold text-black text-sm">:</span>
                    <Form.Item className="m-0" name={`awayScore_${item.matchId}`}>
                      <InputNumber
                        disabled={isDisabled}
                        controls={false}
                        min={0}
                        max={99}
                        maxLength={2}
                        placeholder="-"
                        className="!w-[32px] !h-[32px] text-center text-sm font-bold text-[#3E4C5C] rounded-[6px] [&_input]:!text-center [&_input]:!p-0"
                        style={{ border: '0.83px solid #DCDFE3', textAlign: 'center' }}
                      />
                    </Form.Item>
                  </div>
                </div>

                {/* Away team */}
                <div className="flex flex-col items-center mt-6 gap-1 w-[75px] flex-shrink-0">
                  <div
                    className="w-[50px] h-[50px] rounded-full overflow-hidden bg-white flex items-center justify-center p-[1.5px]"
                    style={{
                      border: '1.2px solid #fff',
                      boxShadow: 'inset 0 0 4px rgba(0,0,0,0.25)'
                    }}
                  >
                    <img
                      src={item.awayLogo}
                      alt={item.awayName}
                      className="w-[90%] h-[90%] max-w-[90%] max-h-[90%] object-contain object-center shrink-0"
                    />
                  </div>
                  <p className="font-['Times_New_Roman'] text-[13px] text-[#36A638] font-bold text-center leading-[16px] tracking-[0.26px] line-clamp-2 w-full">
                    {item.awayName}
                  </p>
                </div>
              </div>

              {/* Bottom: same score + submit */}
              <div className="flex items-center gap-2 mt-2.5">
                <Form.Item className="m-0 flex-1 min-w-0" name={`sameScore_${item.matchId}`}>
                  <InputNumber
                    disabled={isDisabled}
                    controls={false}
                    min={0}
                    maxLength={5}
                    placeholder="Số người dự đoán giống bạn"
                    className="!w-full !h-[34px] rounded-[40px] [&_input]:!text-center [&_input]:!font-['Times_New_Roman'] [&_input]:!text-[13px] [&_input]:!font-bold [&_input]:!tracking-[0.26px] [&_input]:!text-[#6F7F98] [&_input]:!placeholder-[#7E8BA1]"
                    style={{
                      border: '0.83px solid #B8BFC7',
                      background: '#FFFFFF'
                    }}
                  />
                </Form.Item>
                <button
                  type="submit"
                  className="flex-shrink-0 h-[34px] px-3 rounded-[52px] text-white font-['Times_New_Roman'] text-[13px] font-bold tracking-[0.26px] cursor-pointer border border-white"
                  style={{
                    background: '#36A638',
                    boxShadow: 'inset 0px 0.83px 2.49px 3.32px rgba(53,63,55,0.2)'
                  }}
                >
                  Gửi dự đoán
                </button>
              </div>
            </div>
            <div
              className="relative z-0 -mt-2 px-3 pt-3 pb-2 text-center"
              style={{
                background: 'linear-gradient(180deg, #C9FBD0 0%, #A5F0AE 100%)'
              }}
            >
              <p className="font-['Times_New_Roman'] text-[14px] md:text-[16px] font-bold leading-tight text-black tracking-[0.3px]">
                {displayLeagueName}
              </p>
            </div>
          </div>
        );
      });
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full bg-[#E3FEEC]')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-screen fixed top-0 left-0 object-cover block"
        style={{ zIndex: 0 }}
      />
      {/* <div className="fixed bottom-0 left-0 w-auto max-w-[min(40vw,280px)] 2xl:max-w-[320px] hidden xl:block leading-none pointer-events-none z-[1]">
        <img
          src="/lv_left.png"
          alt=""
          className="block w-full h-full object-contain object-left-bottom"
        />
      </div>
      <div className="fixed bottom-0 right-0 w-auto max-w-[min(50vw,420px)] 2xl:max-w-[500px] hidden xl:block leading-none pointer-events-none z-[1]">
        <img
          src="/lv_right.png"
          alt=""
          className="block w-full h-full object-contain object-right-bottom"
        />
      </div> */}
      <RightGif />
      <div className="container w-full relative z-10 pb-4">
        <Header />

        {/* Dự đoán đội vô địch Champions League */}
        {/* <div className="w-full max-w-[990px] mx-auto px-3 mt-2">
          <ChampionLeague
            isSsoLoggedIn={isSsoLoggedIn}
            form={form}
            IP={IP}
            FP={FP}
          />
        </div> */}

        <div
          className="mx-auto mt-4 bg-white rounded-lg border-2 border-solid border-white shadow shadow-primary w-[95%] lg:w-full md:pb-8 
                !max-w-[760px] lg:!max-w-[1200px]"
        >
          <div className="flex px-1 space-x-6 mt-4 justify-center items-center">
            <Button
              type="link"
              icon={
                <img
                  src={LeftArrowIcon}
                  alt="Scroll left"
                  className="w-[12px] h-[20px] object-contain"
                />
              }
              onClick={scrollLeft}
              className="text-green !px-0 !mx-0"
            />
            <div
              className="flex overflow-x-auto scrollbar-custom py-2 !mx-0"
              ref={leagueListRef}
              style={{ scrollBehavior: 'smooth' }}
            >
              {leagues.map((league) => (
                <div
                  key={league.id}
                  className={twMerge(
                    'flex justify-center items-center p-1 mx-2 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105',
                    selectedLeagues.includes(league.id)
                      ? 'bg-[#D7EDD7] shadow-lg shadow-green-500/50 border-2 border-[#36A638]'
                      : 'bg-white/80 backdrop-blur-sm border-2 border-[#DCDFE3] hover:border-[#DCDFE3] hover:shadow-md'
                  )}
                  style={{ width: '120px', minWidth: '60px', border: '1px solid #36A638' }}
                  onClick={() => handleLeagueClick(league.id)}
                >
                  <img src={league.logo} alt={league.name} className="h-12 object-contain" />
                </div>
              ))}
            </div>
            <Button
              type="link"
              icon={
                <img
                  src={RightArrowIcon}
                  alt="Scroll right"
                  className="w-[12px] h-[20px] object-contain"
                />
              }
              onClick={scrollRight}
              className="text-green !px-0 !mx-0"
            />
          </div>
          <div className="w-full h-full">
            <Form
              name="formMatch"
              onFinish={onFinishForm}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
              initialValues={{
                account: '',
                bankDigit1: '',
                bankDigit2: '',
                bankDigit3: '',
                bankDigit4: ''
              }}
            >
              <div className="w-full h-full">
                {isLoading ? (
                  <div className="w-full h-full text-center py-8">
                    <Spin />
                  </div>
                ) : (
                  <div className="flex flex-col w-full h-full items-center mt-2">
                    <div className="mx-auto w-full max-w-[1200px] px-2 md:px-3">
                      <div className="flex w-full flex-col gap-3 md:grid md:grid-cols-[1fr_auto] md:items-center md:gap-3">
                        <div className="order-1 flex w-full items-start gap-2 sm:gap-[13px] md:w-auto">
                          <Form.Item
                            name="account"
                            className="mb-0 min-w-0 flex-1 sm:flex-none"
                            rules={[
                              {
                                required: true,
                                message: 'Vui lòng điền tên đăng nhập!'
                              }
                            ]}
                          >
                            <Input
                              placeholder="Nhập tên đăng nhập ..."
                              maxLength={20}
                              disabled={isSsoLoggedIn}
                              className="!w-full sm:!w-[271px] !h-[40px] md:!h-[44px] !rounded-[30px] !border !border-[#C9C9C9] !bg-white !px-[17px] !py-[10px] font-['Times_New_Roman'] text-[13px] md:text-[14px] !font-bold leading-[20px] tracking-[0.28px] text-[#353535] placeholder:!text-[#978E8E]"
                              style={{
                                fontFamily: "'Times New Roman', serif"
                              }}
                            />
                          </Form.Item>
                          <Form.Item className="mb-0">
                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={isLoadingSubmit}
                              className="times-new-roman-force !w-[120px] sm:!w-[134px] !h-[40px] md:!h-[44px] !rounded-[80px] !border !border-[rgba(255,255,255,0.5)] !px-2 !py-0 text-white font-['Times_New_Roman'] text-[14px] md:text-[16px] !font-bold leading-[24px] shadow-[0px_0px_0px_0px_transparent,inset_0px_0px_0px_0px_transparent]"
                              style={{
                                background: 'linear-gradient(180deg, #86CA88 0%, #2B852D 100%)',
                                fontFamily: "'Times New Roman', Times, serif"
                              }}
                            >
                              Xác nhận
                            </Button>
                          </Form.Item>
                        </div>

                        {!isSsoLoggedIn && (
                          <div className="order-2 md:order-3 md:col-span-2">
                            <p className="mt-1">Nhập 4 số cuối tài khoản ngân hàng</p>
                            {/* 4 ô nhập số tài khoản ngân hàng */}
                            <div className="flex gap-3 justify-start mb-2 mt-1">
                              <Form.Item name="bankDigit1" className="mb-0">
                                <InputNumber
                                  ref={bankDigitRefs[0]}
                                  maxLength={1}
                                  controls={false}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  onChange={handleBankDigitChange(0)}
                                  onKeyDown={handleBankDigitKeyDown(0)}
                                  className="!w-[40px] !h-[40px] text-center text-lg font-medium rounded-[12px] border border-gray-300 [&_input]:!text-center"
                                  style={{ width: 40, height: 40, fontSize: '18px' }}
                                />
                              </Form.Item>
                              <Form.Item name="bankDigit2" className="mb-0">
                                <InputNumber
                                  ref={bankDigitRefs[1]}
                                  maxLength={1}
                                  controls={false}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  onChange={handleBankDigitChange(1)}
                                  onKeyDown={handleBankDigitKeyDown(1)}
                                  className="!w-[40px] !h-[40px] text-center text-lg font-medium rounded-[12px] border border-gray-300 [&_input]:!text-center"
                                  style={{ width: 40, height: 40, fontSize: '18px' }}
                                />
                              </Form.Item>
                              <Form.Item name="bankDigit3" className="mb-0">
                                <InputNumber
                                  ref={bankDigitRefs[2]}
                                  maxLength={1}
                                  controls={false}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  onChange={handleBankDigitChange(2)}
                                  onKeyDown={handleBankDigitKeyDown(2)}
                                  className="!w-[40px] !h-[40px] text-center text-lg font-medium rounded-[12px] border border-gray-300 [&_input]:!text-center"
                                  style={{ width: 40, height: 40, fontSize: '18px' }}
                                />
                              </Form.Item>
                              <Form.Item name="bankDigit4" className="mb-0">
                                <InputNumber
                                  ref={bankDigitRefs[3]}
                                  maxLength={1}
                                  controls={false}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  onChange={handleBankDigitChange(3)}
                                  onKeyDown={handleBankDigitKeyDown(3)}
                                  className="!w-[40px] !h-[40px] text-center text-lg font-medium rounded-[12px] border border-gray-300 [&_input]:!text-center"
                                  style={{ width: 40, height: 40, fontSize: '18px' }}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        )}

                        <div className="order-3 flex w-full flex-wrap items-center justify-center gap-2 md:order-2 md:w-auto md:flex-nowrap md:justify-end">
                          <button
                            onClick={() => setActiveTab('all')}
                            type="button"
                            className={`inline-flex rounded-[80px] border-0 items-center justify-center outline-none px-4 py-2 font-['Times_New_Roman'] text-[12px] md:text-[14px] font-bold leading-[20px] tracking-[0.28px] transition-all duration-200 ${
                              activeTab === 'all'
                                ? 'text-white border-b border-[#EBF6EB] shadow-[inset_0px_4px_8px_0px_rgba(0,0,0,0.24)]'
                                : 'bg-[#DCDFE3] text-[#4E5F73]'
                            }`}
                            style={
                              activeTab === 'all'
                                ? {
                                    background:
                                      'linear-gradient(-31.42deg, rgba(255,255,255,0.4) 26.15%, rgba(255,255,255,0) 70.15%), linear-gradient(90deg, #36A638 0%, #36A638 100%)'
                                  }
                                : undefined
                            }
                          >
                            TẤT CẢ
                          </button>
                          <button
                            onClick={() => setActiveTab('today')}
                            type="button"
                            className={`inline-flex rounded-[80px] items-center justify-center border-0 outline-none px-4 py-2 font-['Times_New_Roman'] text-[12px] md:text-[14px] font-bold leading-[20px] tracking-[0.28px] transition-all duration-200 ${
                              activeTab === 'today'
                                ? 'text-white border-b border-[#EBF6EB] shadow-[inset_0px_4px_8px_0px_rgba(0,0,0,0.24)]'
                                : 'bg-[#DCDFE3] text-[#4E5F73]'
                            }`}
                            style={
                              activeTab === 'today'
                                ? {
                                    background:
                                      'linear-gradient(-31.42deg, rgba(255,255,255,0.4) 26.15%, rgba(255,255,255,0) 70.15%), linear-gradient(90deg, #36A638 0%, #36A638 100%)'
                                  }
                                : undefined
                            }
                          >
                            HÔM NAY
                          </button>
                          <button
                            onClick={() => setActiveTab('tomorrow')}
                            type="button"
                            className={`inline-flex rounded-[80px] items-center justify-center border-0 outline-none px-4 py-2 font-['Times_New_Roman'] text-[12px] md:text-[14px] font-bold leading-[20px] tracking-[0.28px] transition-all duration-200 ${
                              activeTab === 'tomorrow'
                                ? 'text-white border-b border-[#EBF6EB] shadow-[inset_0px_4px_8px_0px_rgba(0,0,0,0.24)]'
                                : 'bg-[#DCDFE3] text-[#4E5F73]'
                            }`}
                            style={
                              activeTab === 'tomorrow'
                                ? {
                                    background:
                                      'linear-gradient(-31.42deg, rgba(255,255,255,0.4) 26.15%, rgba(255,255,255,0) 70.15%), linear-gradient(90deg, #36A638 0%, #36A638 100%)'
                                  }
                                : undefined
                            }
                          >
                            NGÀY MAI
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Widget dự đoán bóng đá */}
                    {/* <div className="w-full h-auto flex justify-center items-center mx-auto mt-2 px-5">
                      <PredictionWidget
                        apiUrl="https://api-football.attcloud.org/api"
                        showHeader={false}
                        refreshInterval={300000}
                      />
                    </div> */}

                    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mt-3 md:mt-4 px-2">
                      {showListItemMatch(getFilteredMatches())}
                    </div>
                  </div>
                )}
                <div className="flex items-center justify-between mt-2"></div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      {/* Popup Lịch Thi Đấu */}
      {showSchedulePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between p-4">
              <h2 className="text-xl font-bold text-[#50b361]">LỊCH THI ĐẤU HOT</h2>
              <button
                onClick={() => setShowSchedulePopup(false)}
                className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
              >
                ×
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <iframe
                src="https://football-widget.pages.dev/"
                width="100%"
                height="600"
                frameBorder="0"
                allowFullScreen
                title="Football Widget"
                className="w-full rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OK9Page;
